module.exports = __webpack_public_path__ + "static/media/workforce_light.dd8cf8b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/SRA/workforce_light.png
// module id = 3539
// module chunks = 3